import CancelOrderDialog from '@/components/OrdersModule/OrderDetail/CancelOrderDialog/CancelOrderDialog'
import { useCancelOrderDialogPortal } from '@/components/OrdersModule/OrderDetail/CancelOrderDialog/contexts/Portal'
import { useCallback, useMemo, useState } from 'react'

type ShowFunction = () => void

export const useCancelOrderDialog = (orderUuid: string): ShowFunction => {
    const [visible, setVisible] = useState(false)

    const show: ShowFunction = useCallback(() => setVisible(true), [])
    const hide = useCallback(() => setVisible(false), [])

    const Dialog = useMemo(
        () => <CancelOrderDialog uuid={orderUuid} onDismiss={hide} />,
        [hide, orderUuid]
    )

    useCancelOrderDialogPortal(visible, Dialog)

    return show
}
